import client from './client';
export default {
	init: function(...args){	
		if(typeof args[0] === 'object'){
			const {url, token, logging, isPrivate} = args[0];
			return new client(url, token, logging, isPrivate);
		}else{
			return new client(...args);
		}
	}
}